import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import './index.less';
const useStyles = createUseStyles({
    sticky: {
        width: 'calc(100% - 48px)',
        // marginTop: 24,
        position: 'sticky',
        left: 24,
        bottom: 0,
        zIndex: 99,
        display: 'flex',
        alignItems: 'center',
        padding: '8px 24px',
        gap: 8,
        justifyContent: 'flex-end',
        backgroundColor: '#fff',
        borderTop: '1px solid #f0f0f0',
        boxShadow: '0 -6px 16px -8px rgb(0 0 0 / 8%), 0 -9px 28px 0 rgb(0 0 0 / 5%), 0 -12px 48px 16px rgb(0 0 0 / 3%)',
        transition: 'width .3s cubic-bezier(.645,.045,.355,1)',
    },
});
export const FreeFooterToolbar = ({ children }) => {
    const [style, setStyle] = useState();
    useEffect(() => {
        const node = document.getElementById('content-layout');
        const anchor = node?.querySelector('.lj-form-wrap__anchor');
        if (anchor) {
            setStyle({
                width: 'calc(100% - 180px)'
            });
        }
    }, []);
    return (_jsx("div", { className: 'lj-footer-toolbar', id: "sticky", style: style, children: children }));
};
